import { defineNuxtPlugin } from '#app/nuxt'
import { LazyWebccBreadcrumb, LazyWebccButton, LazyWebccCancellationStepper, LazyWebccCaptcha, LazyWebccCompanyLogo, LazyWebccDateRangePlusMinusDays, LazyWebccDateRangeSearchSimple, LazyWebccDestinationPicker, LazyWebccExpandable, LazyWebccFeedbackMessage, LazyWebccFieldset, LazyWebccFreeCancellationInfo, LazyWebccHeading, LazyWebccIcon, LazyWebccLink, LazyWebccLoader, LazyWebccLoaderOverlay, LazyWebccMarkdown, LazyWebccModal, LazyWebccOrDivider, LazyWebccPagination, LazyWebccRadioSwitch, LazyWebccScroll, LazyWebccCheckbox, LazyWebccDateRangepicker, LazyWebccForm, LazyWebccFormfield, LazyWebccInput, LazyWebccRadio, LazyWebccSelect, LazyWebccSwitch, LazyBlocks, LazyBlocksBreadcrumbs, LazyBlocksCatalogs, LazyBlocksColumns, LazyBlocksHeading, LazyBlocksHero, LazyBlocksLSODetail, LazyBlocksLSOList, LazyBlocksLSOMedia, LazyBlocksLandingContainer, LazyBlocksLandingH1, LazyBlocksLandingHero, LazyBlocksLandingIFrame, LazyBlocksLandingImageCarouselWithText, LazyBlocksLandingMarkdown, LazyBlocksLandingRecommendations, LazyBlocksLandingTeasers, LazyBlocksLandingTextCarousel, LazyBlocksLandingTextWithImage, LazyBlocksMedia, LazyBlocksMenu, LazyBlocksObjectList, LazyBlocksRichtext, LazyBlocksSearchBar, LazyBlocksStartHeaderTeasers, LazyBlocksStartInspirations, LazyBlocksStartOwnerTeaser, LazyBlocksStartRecommendations, LazyBlocksStartSEOLinks, LazyBlocksStartSeoTeaser, LazyBlocksStartTopDestinations, LazyBlocksStartUSPBar, LazyBlocksStartUSPCards, LazyBlocksStartUSPColumns, LazyBlocksTeaserGrid, LazyBlocksTeaserList, LazyBlocksTextColumns, LazyBlocksUSPBarBlock, LazyBlocksUSPCardsBlock, LazyBlocksUSPColumnsBlock, LazyBlocksUSPCorona, LazyErrorContent, LazyErrorFull, LazyPageBookmarks, LazyPageContent, LazyPageDetails, LazyPageEmails, LazyPageMyrent, LazyPageNewsletter, LazyPageReviews, LazyPageStart, LazyPageUnknown, LazyLiveness, LazyReadiness, LazyStartup } from '#components'
const lazyGlobalComponents = [
  ["WebccBreadcrumb", LazyWebccBreadcrumb],
["WebccButton", LazyWebccButton],
["WebccCancellationStepper", LazyWebccCancellationStepper],
["WebccCaptcha", LazyWebccCaptcha],
["WebccCompanyLogo", LazyWebccCompanyLogo],
["WebccDateRangePlusMinusDays", LazyWebccDateRangePlusMinusDays],
["WebccDateRangeSearchSimple", LazyWebccDateRangeSearchSimple],
["WebccDestinationPicker", LazyWebccDestinationPicker],
["WebccExpandable", LazyWebccExpandable],
["WebccFeedbackMessage", LazyWebccFeedbackMessage],
["WebccFieldset", LazyWebccFieldset],
["WebccFreeCancellationInfo", LazyWebccFreeCancellationInfo],
["WebccHeading", LazyWebccHeading],
["WebccIcon", LazyWebccIcon],
["WebccLink", LazyWebccLink],
["WebccLoader", LazyWebccLoader],
["WebccLoaderOverlay", LazyWebccLoaderOverlay],
["WebccMarkdown", LazyWebccMarkdown],
["WebccModal", LazyWebccModal],
["WebccOrDivider", LazyWebccOrDivider],
["WebccPagination", LazyWebccPagination],
["WebccRadioSwitch", LazyWebccRadioSwitch],
["WebccScroll", LazyWebccScroll],
["WebccCheckbox", LazyWebccCheckbox],
["WebccDateRangepicker", LazyWebccDateRangepicker],
["WebccForm", LazyWebccForm],
["WebccFormfield", LazyWebccFormfield],
["WebccInput", LazyWebccInput],
["WebccRadio", LazyWebccRadio],
["WebccSelect", LazyWebccSelect],
["WebccSwitch", LazyWebccSwitch],
["Blocks", LazyBlocks],
["BlocksBreadcrumbs", LazyBlocksBreadcrumbs],
["BlocksCatalogs", LazyBlocksCatalogs],
["BlocksColumns", LazyBlocksColumns],
["BlocksHeading", LazyBlocksHeading],
["BlocksHero", LazyBlocksHero],
["BlocksLSODetail", LazyBlocksLSODetail],
["BlocksLSOList", LazyBlocksLSOList],
["BlocksLSOMedia", LazyBlocksLSOMedia],
["BlocksLandingContainer", LazyBlocksLandingContainer],
["BlocksLandingH1", LazyBlocksLandingH1],
["BlocksLandingHero", LazyBlocksLandingHero],
["BlocksLandingIFrame", LazyBlocksLandingIFrame],
["BlocksLandingImageCarouselWithText", LazyBlocksLandingImageCarouselWithText],
["BlocksLandingMarkdown", LazyBlocksLandingMarkdown],
["BlocksLandingRecommendations", LazyBlocksLandingRecommendations],
["BlocksLandingTeasers", LazyBlocksLandingTeasers],
["BlocksLandingTextCarousel", LazyBlocksLandingTextCarousel],
["BlocksLandingTextWithImage", LazyBlocksLandingTextWithImage],
["BlocksMedia", LazyBlocksMedia],
["BlocksMenu", LazyBlocksMenu],
["BlocksObjectList", LazyBlocksObjectList],
["BlocksRichtext", LazyBlocksRichtext],
["BlocksSearchBar", LazyBlocksSearchBar],
["BlocksStartHeaderTeasers", LazyBlocksStartHeaderTeasers],
["BlocksStartInspirations", LazyBlocksStartInspirations],
["BlocksStartOwnerTeaser", LazyBlocksStartOwnerTeaser],
["BlocksStartRecommendations", LazyBlocksStartRecommendations],
["BlocksStartSEOLinks", LazyBlocksStartSEOLinks],
["BlocksStartSeoTeaser", LazyBlocksStartSeoTeaser],
["BlocksStartTopDestinations", LazyBlocksStartTopDestinations],
["BlocksStartUSPBar", LazyBlocksStartUSPBar],
["BlocksStartUSPCards", LazyBlocksStartUSPCards],
["BlocksStartUSPColumns", LazyBlocksStartUSPColumns],
["BlocksTeaserGrid", LazyBlocksTeaserGrid],
["BlocksTeaserList", LazyBlocksTeaserList],
["BlocksTextColumns", LazyBlocksTextColumns],
["BlocksUSPBarBlock", LazyBlocksUSPBarBlock],
["BlocksUSPCardsBlock", LazyBlocksUSPCardsBlock],
["BlocksUSPColumnsBlock", LazyBlocksUSPColumnsBlock],
["BlocksUSPCorona", LazyBlocksUSPCorona],
["ErrorContent", LazyErrorContent],
["ErrorFull", LazyErrorFull],
["PageBookmarks", LazyPageBookmarks],
["PageContent", LazyPageContent],
["PageDetails", LazyPageDetails],
["PageEmails", LazyPageEmails],
["PageMyrent", LazyPageMyrent],
["PageNewsletter", LazyPageNewsletter],
["PageReviews", LazyPageReviews],
["PageStart", LazyPageStart],
["PageUnknown", LazyPageUnknown],
["Liveness", LazyLiveness],
["Readiness", LazyReadiness],
["Startup", LazyStartup],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
